import { render, staticRenderFns } from "./SocialSearcher.vue?vue&type=template&id=94b5c6c8"
import script from "./SocialSearcher.vue?vue&type=script&lang=js"
export * from "./SocialSearcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports